// company lib
import generateCompanyFilter from '../lib/generateFilter.lib.company';

export default generateCompanyFilter({
  label: 'Country',
  fn: ({entry, filterValue}) => entry?.Firmographic?.HQCountry === filterValue,
});
